export async function getCmsCollection(collectionName, params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, val]) => {
    if (val !== undefined && val !== null && val !== '') {
      if (Array.isArray(val)) {
        val.forEach((item) => searchParams.append(key, item));
      } else {
        searchParams.append(key, val);
      }
    }
  });
  const qs = searchParams.toString();
  const url = `/_api/public/v2/content/${collectionName}${qs ? `?${qs}` : ''}`;
  try {
    const res = await fetch(url);
    if (!res.ok) {
      console.warn(`CMS fetch failed for ${collectionName}:`, res.status);
      return { items: [], total: 0, limit: 25, offset: 0 };
    }
    const data = await res.json();
    return {
      items: Array.isArray(data.items) ? data.items : (Array.isArray(data) ? data : []),
      total: typeof data.total === 'number' ? data.total : (data.items ? data.items.length : 0),
      limit: data.limit || 25,
      offset: data.offset || 0,
    };
  } catch (err) {
    console.error(`Error fetching CMS collection ${collectionName}:`, err);
    return { items: [], total: 0, limit: 25, offset: 0 };
  }
}

export async function getCmsEntryBySlug(slug) {
  try {
    const res = await fetch(`/_api/public/by-slug/${slug}`);
    if (!res.ok) return null;
    return await res.json();
  } catch (err) {
    console.error(`Error fetching CMS entry by slug ${slug}:`, err);
    return null;
  }
}

let cachedSettings = null;
export async function getCmsSettings() {
  if (cachedSettings) return cachedSettings;
  try {
    const res = await getCmsCollection('indstillinger', { limit: 1 });
    if (res.items && res.items.length > 0) {
      cachedSettings = res.items[0];
      return cachedSettings;
    }
  } catch (err) {
    console.warn('Kunne ikke hente CMS-indstillinger:', err);
  }
  return null;
}

export async function getCmsPage(slugPath) {
  try {
    const res = await getCmsCollection('sider', { slug_sti: slugPath, limit: 1 });
    if (res.items && res.items.length > 0) {
      return res.items[0];
    }
  } catch (err) {
    console.warn(`Kunne ikke hente side med sti ${slugPath}:`, err);
  }
  return null;
}

export async function getCmsFrontpageSections() {
  try {
    const res = await getCmsCollection('forside_sektioner', {
      sort: 'sorteringsorden',
      order: 'asc',
      limit: 20,
    });
    return res.items || [];
  } catch (err) {
    console.warn('Kunne ikke hente forside sektioner:', err);
    return [];
  }
}

